import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import { toByteArray } from 'base64-js';
import mime from 'mime';
export const parseDataUrl = dataUrl => {
  const arr = dataUrl.split(',');
  const match = arr[0].match(/:(.*?);/);
  const mime = match ? match[1] : '';
  const base64 = arr[1];
  const size = Math.round(base64.length * 3 / 4);
  return {
    base64,
    mime,
    size
  };
};
export const archiveFileToFile = archive => new File([toByteArray(archive.content)], archive.name, {
  type: archive.format
});
export const archiveFileToDataUrl = archive => `data:${archive.format};base64,${archive.content}`;
export const dataUrlToFile = (dataUrl, name) => {
  const {
    base64,
    mime
  } = parseDataUrl(dataUrl);
  return new File([toByteArray(base64)], name, {
    type: mime
  });
};
export const dataUrlToArchiveFile = (dataUrl, name) => {
  const {
    base64,
    mime,
    size
  } = parseDataUrl(dataUrl);
  return {
    name,
    content: base64,
    format: mime,
    size
  };
};
export const dataUrlToBase64 = dataUrl => parseDataUrl(dataUrl).base64;
export const textToBlob = (text, mime) => new Blob([text], {
  type: mime
});
export const jsonToBlob = (json, mime) => {
  const text = JSON.stringify(json, undefined, 2);
  return textToBlob(text, mime);
};
export const blobToFile = (blob, name, mime) => new File([blob], name, {
  type: mime !== null && mime !== void 0 ? mime : blob.type
});
export const uInt8ToFile = (uInt8, mime, name) => new File([uInt8], name, {
  type: mime
});
export const base64ToDataUrl = (base64, mime) => `data:${mime};base64,${base64}`;
export const fileToDataUrl = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
export const fileToBase64 = file => new Promise((resolve, reject) => {
  fileToDataUrl(file).then(result => resolve(result.split('base64,')[1])).catch(error => reject(error));
});
export const fileToArchiveFile = file => new Promise((resolve, reject) => {
  fileToBase64(file).then(base64 => resolve({
    name: file.name,
    format: file.type,
    size: file.size,
    content: base64
  })).catch(error => reject(error));
});
export const addExtensionToName = (baseName, mimeType) => {
  const ext = mime.getExtension(mimeType);
  return ext ? `${baseName}.${ext}` : baseName;
};
export const getExtensionFromMime = mimeType => mime.getExtension(mimeType);
export const getMimeFromExtension = extension => mime.getType(extension);
export const imageDimensions = dataUrl => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => {
    const {
      width,
      height,
      naturalWidth,
      naturalHeight
    } = image;
    resolve({
      width,
      height,
      naturalWidth,
      naturalHeight
    });
  };
  image.onerror = error => reject(error);
  image.src = dataUrl;
});